<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48" style="height: 100px">
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item label="项目">
              <a-select
                style="max-width: 200px;min-width: 100%"
                showSearch
                :disabled="showable"
                placeholder="请选择"
                v-decorator="['projectId', {rules: [{required: true, message: '请选择项目'}]}]"
                :options="projectList"
                v-model="queryParam.projectId"
                optionFilterProp="children"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="机械名称">
              <a-input placeholder="请输入机械名称" v-model="queryParam.name" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="机械类型">
              <a-input placeholder="请输入机械类型" v-model="queryParam.type" />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => {queryParam = {}}" style="margin-left: 8px">重置</a-button>
          </a-col>
          <a-col :md="8" :sm="24" >
            <a-button type="primary" icon="download" @click="download">Excel导出</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      bordered
      :isInquire="false"
      disabled="showable"
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
    </s-table>
  </a-card>
</template>
<script>
import moment from 'moment'
import { TableMixin } from '@/mixins/TableMixin'
import { dropProjectList } from '@/api/project/ProjectInfo'
import { fetchList, download } from '@/api/statement/companyMechanicalCost'
import ACol from 'ant-design-vue/es/grid/Col'

export default {
  name: 'CompanyMaterialCost',
  components: { ACol },
  mixins: [TableMixin],
  data () {
    return {
      projectList: [], // 项目
      supplierList: [], // 供货人
      purchaserList: [], // 采购人
      showable: false,
      clearDate: undefined,
      queryParam: {
        projectId: undefined,
        type: undefined,
        name: undefined
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '62px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '项目名称',
          dataIndex: 'projectName'
        },
        {
          title: '名称',
          dataIndex: 'name'
        },
        {
          title: '类型',
          dataIndex: 'type'
        },
        {
          title: '工日单价',
          dataIndex: 'unitPrice',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' - ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '开始日期',
          dataIndex: 'startDate'
        },
        {
          title: '结束日期',
          dataIndex: 'endDate'
        },
        {
          title: '总价',
          dataIndex: 'totalPrice',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' - ' : Number(text).toFixed(2)}
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    onChange (value, dateString) {
      this.queryParam.startTime = moment(dateString[0]).startOf('day').format('YYYY-MM-DD HH-mm-ss')
      this.queryParam.endTime = moment(dateString[1]).endOf('day').format('YYYY-MM-DD HH-mm-ss')
      if (this.queryParam.startTime === 'Invalid date') {
        this.queryParam.startTime = ''
        this.queryParam.endTime = ''
      }
    },
    init () {
      dropProjectList().then(res => {
        this.projectList = res.data
        this.queryParam.projectId = this.projectList[0].value
        this.queryPage()
      })
    },
    download () {
      download(this.queryParam).then(res => {
        const blbo = new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' })
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blbo)
        link.download = '公司机械成本统计.xlsx'
        link.click()
      }).catch((e) => {
        this.$message.warning('下载失败')
      })
    }

  },
  created () {
    this.init()
  }
}
</script>
<style scoped>

</style>
